/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseApiUrl = 'https://me-commenting-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://me-commenting-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/me-commenting-tool-api/public/'
  appBaseUrl = 'http://localhost:2200/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
